export default __webpack_public_path__ + "static/media/Earn.f811432c.svg";